import * as types from './constants';

// End Reimbursements
export const endReimbursementsRequest = data => (
  { type: types.END_REIMBURSEMENTS_REQUEST, payload: data }
);

export const endReimbursementsDone = data => (
  { type: types.END_REIMBURSEMENTS_DONE, payload: data }
);

export const endReimbursementsFailed = errors => (
  { type: types.END_REIMBURSEMENTS_FAILED, payload: errors }
);